import PropTypes from '../_util/vue-types';

var ILazyRenderBoxPropTypes = {
  visible: PropTypes.bool,
  hiddenClassName: PropTypes.string
};

export default {
  props: ILazyRenderBoxPropTypes,
  render: function render() {
    var h = arguments[0];

    return h('div', [this.$slots['default']]);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-dialog/LazyRenderBox.js
// module id = 808
// module chunks = 0